import styles from "./ResumeContent.module.css";
export default function ResumeContent() {
	return (
		<div id="main-content" className={styles.resume}>
			<h1>Benjamin John Wesson</h1>
			<p className={styles.text}>
				Potomac, MD • (301) 461-3202 • benjamin.j.wesson@gmail.com •
				linkedin.com/bwesson • github.com/benwesson
			</p>
			<br />
			<h2 className={styles.header}>EDUCATION</h2>
			<hr />
			<h3>The University of Maryland | College Park, MD</h3>
			<h3 className={styles.header}>
				Bachelor of Science in Computer Information Science
			</h3>
			<p className={styles.text}>
				Relevant coursework: INST377-DYNAMIC WEB APPLICATIONS,
				INST447-DATA SOURCE & MANIPULATION, INST327-DATABASE DESIGN
				MODELING, INST326-OBJECT-ORIENTED PROGRAMING INFO SCI,
				INST490-CAPSTONE FOR INFO SCI
			</p>
			<br />
			<h2 className={styles.header}>Skills</h2>
			<hr />
			<p className={styles.text}>
				Skills: HTML, CSS, JavaScript, React, Next.js, TypeScript,
				Prisma ORM, Version Control (Git), Client Communication, Team
				Leadership, Team Collaboration, , SQLite, Python (pandas,
				seaborn, scikit learn and matplotlib), Figma
			</p>
			<br />
			<h2 className={styles.header}>RELEVANT EXPERIENCE</h2>
			<hr />
			<h3 className={styles.header}>
				UMD iConsultancy Program - Engineer & Team Lead | College Park,
				MD
			</h3>
			<ul className={styles.text}>
				<li>
					Redesigned a responsive website, increasing site usability
					by implementing modern HTML, CSS, and WordPress frameworks
				</li>
				<li>
					Led a cross-functional team of 5, meeting with our professor
					and client bi-weekly, by organizing team roles and
					facilitating development sprints.
				</li>
				<li>
					Created comprehensive codebase documentation, allowing for
					future development and maintenance, by systematically
					detailing code structures and workflows.
				</li>
				<li>
					Conducted a research spike on the possibility of an
					interactive campus-community portal using reusable React
					components to build scalable architecture.
				</li>
			</ul>
			<br />
			<h2 className={styles.header}>Projects</h2>
			<hr />
			<h3 className={styles.header}>Stock Market Portfolio Dashboard </h3>
			<ul className={styles.text}>
				<li>
					Built a stock dashboard web app where users can add mock
					funds to simulate stock market actions.
				</li>
				<li>
					Created an interactive GUI experience allowing users to
					track changes to their portfolio value.
				</li>
				<li>
					Implemented API caching for improved performance and reduced
					load on the API for redundant requests.
				</li>
				<li>
					Allowed users to create accounts on the website to save
					their portfolio.
				</li>
				<li>
					Utilized: JavaScript, HTML, CSS, React, Next.js, Marketstack
					API, Shadcn, Neon postgress, NextAuth.js
				</li>
			</ul>
			<h3 className={styles.header}>Food Blog App </h3>
			<ul className={styles.text}>
				<li>
					Built a CRUD app where users can login, create posts, upload
					images and interact with content from other users.
				</li>
				<li>
					Implemented Prisma ORM to manage user account details and to
					perform server actions.
				</li>

				<li>
					Allowed users to use Google Gemini to add additional details
					to their posts.
				</li>
				<li>
					Utilized: HTML, CSS, JavaScript, React, Next.js, Prisma,
					MongoDB, NextAuth.js, Supabase, Gemini api
				</li>
			</ul>
			<h3 className={styles.header}>Blue Crab Population Predictor </h3>
			<ul className={styles.text}>
				<li>
					Predicted future blue crab populations in Chesapeake Bay for
					2025 using 30 years of ecological and climate data,
					supporting local environmental forecasting
				</li>
				<li>
					Improved model accuracy through feature and regression
					engineering, using climate variables as predictive inputs.
				</li>
				<li>
					Visualized long-term population trends and climate
					correlations using Python libraries to support
					interpretability.
				</li>
				<li>
					Utilized: Python, Pandas, Scikit-learn, Seaborn, Matplotlib.
				</li>
				<li>
					Utilized: Python, Pandas, Scikit-learn, Seaborn, Matplotlib.
				</li>
			</ul>
			<br />
			<h2 className={styles.header}>HOBBIES</h2>
			<hr />
			<p>
				Hobbies: Winter sports, biking, being outdoors, hiking, vegetable
				gardening, and badminton.
			</p>
			<br />
		</div>
	);
}
